import { render, staticRenderFns } from "./ObjectMarksView.vue?vue&type=template&id=973e83dc&scoped=true&"
import script from "./ObjectMarksView.vue?vue&type=script&lang=ts&"
export * from "./ObjectMarksView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973e83dc",
  null
  
)

export default component.exports